import { render, staticRenderFns } from "./changeabout.vue?vue&type=template&id=57b6c631&scoped=true"
import script from "./changeabout.vue?vue&type=script&lang=js"
export * from "./changeabout.vue?vue&type=script&lang=js"
import style0 from "./changeabout.vue?vue&type=style&index=0&id=57b6c631&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b6c631",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/www/prod-cn-snote-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57b6c631')) {
      api.createRecord('57b6c631', component.options)
    } else {
      api.reload('57b6c631', component.options)
    }
    module.hot.accept("./changeabout.vue?vue&type=template&id=57b6c631&scoped=true", function () {
      api.rerender('57b6c631', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/about/changeabout.vue"
export default component.exports